require('./retailLoanNotAvailable.scss');
//@vendor
const React = require('react');
//@component
const WizardError = require('components/commons/wizardError/wizardError');
//@core
const { formatText, FormattedText } = require('core/i18n').i18n;

class RetailLoanNotAvailable extends React.Component {
    render() {
        const errorMessage = formatText('retailLoanNotAvailable-errorMessage');
        const mainButtonLabel = formatText('retailLoanNotAvailable-redirect');
        const mainButton = {
            url: 'myprofile/global',
            label: mainButtonLabel.toUpperCase()
        };

        return (
            <div className="col-xs-12">
                <WizardError
                    errorMessage={errorMessage}
                    mainButton={mainButton}
                >
                    <FormattedText
                        value="retailLoanNotAvailable-moreInfo"
                        className="retail-loan-not-available__message"
                    />
                </WizardError>
            </div>
        );
    }
}

module.exports = RetailLoanNotAvailable;
